module.exports = __webpack_public_path__ + "9f961ade69ae82326db4c3085bed937d.pdf";